interface UserConfig {
  id?: number;
  name?: string;
  icon?: string;
  email?: string;
  signedIn?: boolean;
  permissions?: string[];
}

export default class User {
  public readonly id: number = 0;
  public readonly name: string = "guest";
  public readonly icon: string = "";
  public readonly email: string = "";
  public readonly signedIn: boolean = false;

  public constructor(params: UserConfig = {}) {
    if (params.id) this.id = params.id;
    if (params.name) this.name = params.name;
    if (params.icon) this.icon = params.icon;
    if (params.email) this.email = params.email;
    if (params.signedIn) this.signedIn = params.signedIn;
    if (params.permissions) this.permissions = params.permissions;
  }

  public can(permission: string): boolean {
    return this.permissions.includes(permission);
  }

  private permissions: string[] = [];
}
